import PicklistMetadata from "../PicklistMetadata";

// WHERE a referenced secret is read, which is not the same question as where it lives.
//
// Platform is the default and the old behaviour: we resolve the reference and the ANSWER travels to
// whoever does the work. Agent means the REFERENCE travels and the agent reads the secret where it
// is, with its own ambient identity and nothing from us -- so the password never crosses the
// boundary, and rotating it stops involving us at all.
//
// Deliberately a choice rather than something inferred from who owns the source. Inferred, a
// credential would change meaning the moment a source moved between hosted and agent harvesting.
class ConnectionCredentialResolveAtPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "ConnectionCredentialResolveAt";
        this.bounded = true;
        this.enterpriseComponent = "PickList Generic";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.searchSpecification = null;
        this.sortSpecification = null;
        this.static = true;
        this.typeField = "Type";
        this.typeValue = "Connection Credential Resolve At";
        this.typeValue2 = null;
        this.visibilityType = null;
    }
}

export default ConnectionCredentialResolveAtPicklistMetadata;
